import PasskeyAPI from './PasskeyAPI'
import AddressAPI from './AddressAPI'
import PreferencesAPI from './PreferencesAPI'
import OAuthAPI from './OAuthAPI'

export default {
  passkey: new PasskeyAPI(),
  address: new AddressAPI(),
  preferences: new PreferencesAPI(),
  oauth: new OAuthAPI(),
}
